import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function DeepLinkHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check URL query params first, then sessionStorage as fallback.
    // sessionStorage is needed because OIDC onSigninCallback strips
    // query params from the URL before this component mounts.
    const customerId =
      searchParams.get('customerId') ||
      sessionStorage.getItem('deeplink_customerId');

    if (customerId) {
      sessionStorage.removeItem('deeplink_customerId');
      navigate(`/customers/${customerId}`, { replace: true });
      return;
    }

    const disputeId =
      searchParams.get('disputeId') ||
      sessionStorage.getItem('deeplink_disputeId');

    if (disputeId) {
      sessionStorage.removeItem('deeplink_disputeId');
      navigate(`/disputes/all/${disputeId}`, { replace: true });
    }
  }, [searchParams, navigate]);

  return null;
}
